import React, {useEffect, useState} from 'react';
import {Button, Dialog, Flex} from '@priority-software/priority-style-react';
import {SuccessComponent} from '../SuccessComponent';
import texts from '../../texts';
import styles from './styles.module.scss';
import {getUserFullName} from '../../actions/user';

type Props = {
    onClose: () => void;
    owner: string;
    currentStepName: string;
};

export const StepCompletedDialog = (props: Props) => {
    const {onClose, owner} = props;
    const [ownerFullName, setOwnerFullName] = useState('');
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            const res = await getUserFullName(owner);
            setOwnerFullName(res);
            setLoading(false);
        })();
    }, []);

    if (isLoading) return null;

    return (
        <Dialog
            componentClasses={styles.dialog}
            isOpen={true}
            onClose={onClose}
            width={728}
            content={
                <SuccessComponent
                    title={texts.step_completed_title}
                    subtitle={texts.step_completed_description.replace('"XXX"', ownerFullName)}
                />
            }
            footer={
                <Flex justifyContent="flex-end">
                    <Button
                        componentClasses={styles.submitButton}
                        size="medium"
                        skin="primary"
                        onClick={onClose}
                    >
                        {texts.done}
                    </Button>
                </Flex>
            }
        />
    );
};
